import { getCustomer, getProfile } from '@mews-commander/legacy-entities/src/ducks';
import { getCompany } from '@mews-commander/legacy-entities/src/ducks/companies';
import { useCommanderSelector } from '@mews-commander/utils';
import { Identifiable } from '@mews/std';
import { CompanyLink } from './CompanyLink';
import { CustomerLink } from './CustomerLink';
import ProfileLink from './ProfileLink';

export const AccountLink = ({ id }: Identifiable) => {
    const customer = useCommanderSelector((state) => getCustomer(state, { id }));
    const company = useCommanderSelector((state) => getCompany(state, { id }));
    const profile = useCommanderSelector((state) => getProfile(state, { id }));

    if (customer) {
        return <CustomerLink id={id} />;
    }
    if (company) {
        return <CompanyLink id={id} />;
    }
    if (profile) {
        return <ProfileLink profileId={id} />;
    }

    return <></>;
};
